/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'seg-image-selection';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleType = `${prefix}.columnTitleType`;
export const columnTitleVersion = `${prefix}.columnTitleVersion`;
export const columnTitleAttributes = `${prefix}.columnTitleAttributes`;
export const nextBtnLabel = `${prefix}.nextBtnLabel`;
export const emptyCompatibleImageLabel = `${prefix}.emptyCompatibleImageLabel`;
export const currentVersionLabel = `${prefix}.currentVersionLabel`;
export const continueLabel = `${prefix}.continueLabel`;
export const compatibleUpdatesHeader = `${prefix}.compatibleUpdatesHeader`;

export const ENGLISH = {
    [columnTitleType]: 'Type',
    [columnTitleVersion]: 'Version',
    [columnTitleAttributes]: 'Attributes',
    [nextBtnLabel]: 'Next',
    [emptyCompatibleImageLabel]: 'No compatible image found for the selected SEGs.',
    [currentVersionLabel]: '{0} (current)',
    [continueLabel]: 'Continue',
    [compatibleUpdatesHeader]: 'Compatible Updates',
};
